<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4317 24.2678L13.5748 18.1324C13.2575 17.8486 12.743 17.8486 12.4258 18.1324L5.56855 24.2678C5.31259 24.4968 4.875 24.3346 4.875 24.0108V3.25C4.875 2.4375 5.60261 1.625 6.49992 1.625H19.5001C20.3977 1.625 21.125 2.4375 21.125 3.25V24.0106C21.1253 24.3346 20.6877 24.4968 20.4317 24.2678ZM8.125 7.3125C8.125 6.86377 8.48877 6.5 8.9375 6.5H17.0625C17.5112 6.5 17.875 6.86377 17.875 7.3125C17.875 7.76123 17.5112 8.125 17.0625 8.125H8.9375C8.48877 8.125 8.125 7.76123 8.125 7.3125ZM8.9375 9.75C8.48877 9.75 8.125 10.1138 8.125 10.5625C8.125 11.0112 8.48877 11.375 8.9375 11.375H17.0625C17.5112 11.375 17.875 11.0112 17.875 10.5625C17.875 10.1138 17.5112 9.75 17.0625 9.75H8.9375Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "i-bookmark",
  props: {
    size: {
      type: String|Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg{
  transition: all 0.5s;
  path{
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/bookmark.vue